import { useState } from 'react'

export default function useForm(defaultValues) {
    const [values, setValues] = useState(defaultValues);
    
    function setValue(key, value){
        setValues({
            ...values,
            [key]: value,
        });
    }
    
    function handleChange(e) {
        setValue(e.target.getAttribute('name'), e.target.value);
    }
    
    function clearForm() {
        setValues(defaultValues);
    }
    
    return {
        values,
        handleChange,
        clearForm,
    }
}